import { getResizedImage } from '@zep/utils';
import S from './LandingExperience.module.scss';
export const SpaceCard = (props: SpaceCardProps) => {
  const {
    title,
    imageUrl,
    imageAlt
  } = props;
  return <div className={S.card} data-sentry-component="SpaceCard" data-sentry-source-file="SpaceCard.tsx">
      <div className={S.img}>
        {}
        <img src={getResizedImage(imageUrl, 500)} alt={imageAlt || title} />
      </div>
      <span className={S.text}>{title}</span>
    </div>;
};
type SpaceCardProps = {
  title: string;
  imageUrl: string;
  imageAlt: string;
};